module.exports = __webpack_public_path__ + "static/media/need-help-icon.d526b9f7.svg";